import React from "react";
import { Fragment } from "react";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchClientPagesList, fetchDeleteClient } from "../actions/client";
import { statusOrder, statusRender } from "../utils/cellRenderTable";
import { baseUrl } from "../utils";
import { fetchClearOrderDetailList, fetchOrderList } from "../actions/product";

const OrderList = () => {
  const dispatch = useDispatch();

  const { dataOrderList } = useSelector((state) => state.productReducer);

  useEffect(() => {
    dispatch(fetchOrderList());
    dispatch(fetchClearOrderDetailList());
  }, [dispatch]);

  //akcija brisanja iz liste
  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteClient(pageId));
  };

  const imageRenderer = (params) => (
    <img
      src={baseUrl + "images/" + params.data.acImage}
      className="img-fluid image-preview-block-table"
      alt="UP IT"
    />
  );

  const customCellRenderer = (params) => (
    <ButtonColumn
      editLink={`/adminManager/order-edit/` + params.data.id}
      value={params}
      submitActionModal={handleSubmitModal}
    />
  );

  //settings za tabelu
  const columnDefs = [
    {
      headerName: "Broj porudžbine",
      field: "receiptNumber",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Ukupno",
      field: "amount",
      filter: "agTextColumnFilter",
      valueGetter: (params) => {
        return params.data.amount ? Number(params.data.amount) : null;
      },
      valueFormatter: (params) => {
        if (params.value == null) return "";
        return params.value.toLocaleString("sr-RS", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },

    {
      headerName: "Dostava",
      field: "shippingType",
      filter: "agTextColumnFilter",
      valueGetter: (params) => {
        if (!params.data || !params.data.shippingType) return null;
        switch (params.data.shippingType) {
          case "AKS":
            return "Aks";
          case "D_EXPRESS":
            return "D Express";
          case "BEX":
            return "Bex";
          default:
            return "";
        }
      },
    },
    {
      headerName: "Datum kreiranja",
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: (params) => {
        return params.data.createdAt ? new Date(params.data.createdAt) : null;
      },
      valueFormatter: (params) => {
        if (!params.value) return "";
        return params.value.toLocaleDateString("sr-RS", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      },
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          if (!cellValue) return -1; // prazna vrednost -> izbacuje
          const cellDate = new Date(cellValue);

          // normalizacija na ponoć (da sat/minut/sekund ne smetaju)
          const cellDateOnly = new Date(
            cellDate.getFullYear(),
            cellDate.getMonth(),
            cellDate.getDate()
          );

          if (cellDateOnly.getTime() === filterLocalDateAtMidnight.getTime()) {
            return 0; // jednako
          }
          return cellDateOnly < filterLocalDateAtMidnight ? -1 : 1;
        },
      },
    },

    {
      headerName: "Status",
      field: "status",
      filter: "agTextColumnFilter",
      cellRenderer: statusOrder,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "APPROVE":
            return "Prihvaćeno";
          case "DECLINED":
            return "Odbijeno";
          case "PENDING":
            return "Na čekanju";
          default:
            return "";
        }
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 60,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb title="Pregled porudžbina" type="order-lista" />
      <AggridTable rowData={dataOrderList} columnDefs={columnDefs} />
    </Fragment>
  );
};

export default OrderList;
